import { TableCell, Typography } from '@mui/material';
import { RouteEnum } from 'App';
import { dateTime, HeadCell, SimpleTable, TitlePanels, ToAuditButton } from '@shared';
import { AuditsInProgressPropsType, ColumnsIdsInProgressTable } from './AuditQueue.types';

const headCellsInProgressTable: readonly HeadCell<ColumnsIdsInProgressTable>[] = [
  {
    id: 'exam start',
    label: 'Exam Start',
  },
  {
    id: 'exam end',
    label: 'Exam End',
  },
  {
    id: 'audit start',
    label: 'Audit Start',
  },
  {
    id: 'resume button',
    label: '',
  },
];

export function AuditsInProgressTable({ auditsInProgress }: AuditsInProgressPropsType) {
  return (
    <section>
      <TitlePanels titles={['My audits in progress']} />
      <SimpleTable
        columns={headCellsInProgressTable}
        rows={auditsInProgress}
        entityName={'audit'}
        renderElems={({ uuid, ...rest }) => {
          const arr = Object.entries(rest);
          // // swap order
          [arr[0], arr[1], arr[2]] = [arr[1], arr[2], arr[0]];
          return (
            <>
              {arr.map(([keyName, value]) => (
                <TableCell key={keyName}>
                  <Typography component='time' variant='tableCell'>
                    {dateTime(value, keyName)}
                  </Typography>
                </TableCell>
              ))}
              <TableCell>
                <ToAuditButton
                  navigate
                  uuid={uuid}
                  title={'Resume Audit'}
                  route={RouteEnum.EnhancedAudit}
                />
              </TableCell>
            </>
          );
        }}
      />
    </section>
  );
}
